export default "__VITE_ASSET__8S2cIMWL__"